import React ,{ Component }from "react";
import { FiCast , FiLayers , FiUsers , FiMonitor } from "react-icons/fi";

const ServiceList = [
    {
        icon: <FiCast />,
        title: 'Business Stratagy',
        description: 'Tailored business strategies for growth and success. Data-driven insights, expert consultants, and informed decision-making for sustainable results.'
    },
    {
        icon: <FiLayers />,
        title: 'Website Development',
        description: 'Custom web development solutions for your online presence. Expert coding, responsive design, and seamless user experiences to boost your digital success..'
    },
    {
        icon: <FiUsers />,
        title: 'Marketing & Reporting',
        description: 'Comprehensive marketing and reporting solutions to enhance your business visibility. Data-driven insights and analytics for informed decision-making and measurable results.'
    },
    { 
        icon: <FiMonitor />,
        title: 'Mobile App Development',
        description: 'Innovative mobile app development tailored to your business needs. Engaging user interfaces, seamless functionality, and optimal performance for maximum impact..'
    },
    {
        icon: <FiUsers />,
        title: ' Financial website design ',
        description: 'Modern financial website design services that showcase your professionalism. Clean interfaces, intuitive navigation, and secure features to build trust with clients..'
    },
    { 
        icon: <FiMonitor />,
        title: 'Arabic UX design',
        description: 'Expert Arabic UX design services for an exceptional user experience. Intuitive interfaces, culturally sensitive designs, and seamless interactions tailored to Arabic-speaking users..'
    }
]


class ServiceThree extends Component{
    render(){
        const {column } = this.props;
        const ServiceContent = ServiceList.slice(0 , this.props.item);
        
        return(
            <React.Fragment>
                <div className="row">
                    {ServiceContent.map( (val , i) => (
                        <div className={`${column}`} key={i}>
                            <a href="/service-details">
                                <div className="service service__style--2">
                                    <div className="icon">
                                        {val.icon}
                                    </div>
                                    <div className="content">
                                        <h3 className="title">{val.title}</h3>
                                        <p>{val.description}</p>
                                    </div>
                                </div>
                            </a>
                        </div>
                    ))}
                </div>
            </React.Fragment>
        )
    }
}
export default ServiceThree;
